import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import DefaultProfileImage from '../../assets/images/profiles/profile.jpg';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setNotificationDetails } from '../../redux/slice/NotificationSlice';
import { fetchAllPermissions } from '../../redux/slice/RoleManagementSlice';
import roles from '../../utils/api/roles';
import CheckBoxButtons from '../check-box-button/CheckBoxButtons';
import CustomInput from '../custom-input/CustomInput';

interface RoleSidePanelProperties {
  fetchIdFrom: 'queryParams' | 'props';
  id?: string;
}

interface RoleDataProperties {
  id: string;
  name: string;
  responsibility: string;
  permissions: string[];
  users: {
    name: string;
    status: string;
    email: string;
    phoneNumber: string;
  }[];
}

/**
 * Station side panel
 * @param properties
 * @returns
 */
function RoleSidePanel(properties: RoleSidePanelProperties) {
  const { fetchIdFrom, id } = properties;

  const dispatch = useAppDispatch();
  const { permissionsList } = useAppSelector((state) => state.roles);
  const [searchParameters] = useSearchParams();

  const [roleData, setRoleData] = useState<RoleDataProperties>();

  /**
   * Function to fetch station details
   * @param roleId
   */
  const handleFetchStationDetails = async (roleId: string) => {
    roles
      .fetchRoleById(roleId)
      .then((response) => {
        setRoleData(response?.data);
      })
      .catch((error) => {
        dispatch(
          setNotificationDetails({
            type: 'error',
            notificationDetails: {
              statusCode: error?.response?.data?.code || 200,
              message: error?.response?.data?.message || 'Something went wrong!',
            },
          }),
        );
      });
  };

  useEffect(() => {
    let roleId;
    if (fetchIdFrom === 'queryParams') {
      roleId = searchParameters.get('roleId');
    } else if (fetchIdFrom === 'props') {
      roleId = id;
    }

    if (!roleId) {
      return;
    }

    handleFetchStationDetails(roleId);
  }, [searchParameters, id]);

  useEffect(() => {
    if (permissionsList.length === 0) {
      dispatch(fetchAllPermissions());
    }
  }, []);

  return (
    <div className="role-side-panel-wrap">
      <div className="role-details-container">
        <CustomInput
          name="name"
          inputLabel=""
          type="text"
          placeholder="Enter the name"
          value={roleData?.name || ''}
          onChangeValue={() => {}}
          valueRequired
          readOnly
          fontSize="small"
        />
        <p className="role-responsibility">{roleData?.responsibility}</p>
        <div className="role-permissions">
          <CheckBoxButtons
            name="permissions"
            list={permissionsList}
            inputLabel="Permissions"
            value={roleData?.permissions || []}
            onChangeValue={() => {}}
            valueRequired
          />
        </div>
      </div>
      <div className="user-details-container">
        {roleData?.users?.map((eachUser) => (
          <div className="each-user-details-container">
            <div className="user-details">
              <img src={DefaultProfileImage} alt="" className="user-profile-image" />
              <div className="user-details-content">
                <h6>{eachUser?.name}</h6>
                <p>{eachUser?.email || eachUser?.phoneNumber}</p>
              </div>
            </div>
            <div className={`user-status ${eachUser?.status ? 'active' : 'in-active'}`}>
              <p>{eachUser?.status ? 'Active' : 'Inactive'}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default RoleSidePanel;
